import React, { FC, useMemo } from 'react'
import { observer } from 'mobx-react'
import { cartMobx, discountMobx, orderMobx, restaurantCenter, restaurantConfig, storeMobx } from 'restaurant'
import { timePickMobx, payPlanMobx, deliveryMobx, multiPersonMobx, buyTogetherMobx, memberMobx, payRechargeMobx } from '@mobxStore'
import { IonFooter } from '@ionic/react'
import { getHistoryNew, showMsg, confirmLayer, loadingLayer, modalLayer } from '@utils'
import { format, ddayjs, delayTime } from '@dt/fe-utils'
import { cloneDeep, sortBy, uniqBy } from '@dt/fe-utils/dist/lodash'
import deliveryController from '@ctrls/deliveryController'
import { payOrder } from '@common/utils/pay'
import { Avatar, ConfirmModal, Icon, SelectAddressModal } from '@cps'
import { SettlementCard } from '@pages/checkout/component'
import { TEnumUserStatus } from '@mobx/cashier/multiPerson.mobx'
import { TEEatType } from 'restaurant/mobx/store.mobx'
import '@pages/checkout/component/CartFooter/index.scss'

interface IProps {
  handleOutCart: () => void;
}

const CartFooter: React.FC<IProps> = (props) => {
  const { handleOutCart } = props
  const history = getHistoryNew()
  const { cartResult, info } = cartMobx
  const { payMode } = info
  const { viewAddresses } = deliveryMobx
  const { addressInfo } = buyTogetherMobx
  const storeInfo = storeMobx.info
  const eatType = cartMobx.info.eatType
  // const isCanSave = cartMobx.cartResult.totalCnt && cartMobx.cartResult.isCanSave && menuMobx.isAvailable && storeInfo.inSale
  const isCanCheckout = restaurantConfig.codeType === 'brand' ? (!!(timePickMobx.canPick && storeInfo.isMobileBookingOrder) || storeInfo.inSale) : storeInfo.inSale
  const isCanOrder = cartMobx.cartResult.totalCnt && cartResult.isCanSave && (((storeInfo.isMobileBookingOrder || timePickMobx.timePickList.length) && (cartMobx.info.startTime || (cartMobx.info.startTime === '' && storeInfo.inSale))) || storeInfo.inSale)
  const isCanDelivery = (eatType === 'delivery' && cartMobx.cartResult.itemActualPrice >= deliveryMobx.leastFee) || eatType !== 'delivery'
  const isCanSingleSale = cartMobx.canSingleSale

  // 处理保存订单
  const handleSaveOrder = () => {
    // 判断联系信息是否填写
    if (eatType === 'delivery') {
      if (!addressInfo.address) {
        if (viewAddresses?.length) {
          modalLayer(SelectAddressModal, { }, 'SelectAddressModal').then(() => {
          }, () => { })
        } else {
          deliveryController.editAddressModal({
            eatType: TEEatType.delivery,
            callback (store) {
            }
          })
        }
        return
      } else {
        deliveryMobx.setAddress(addressInfo, '')
      }
    } else {
      const memberInfo = memberMobx.memberInfo
      cartMobx.setContact({
        contactName: memberInfo.nickName,
        contactMobile: memberInfo.mobile,
        contactInfo: {}
      })
    }
    // 判断外卖起送金额
    if (!isCanDelivery) {
      return
    }
    // 不能单点
    if (!isCanSingleSale) {
      return
    }
    // 预约时间
    if (cartMobx.info.startTime) {
      // 如果开启预约时间，判断当前时间是否大于3分钟
      const makeTime = storeInfo?.preparationTime?.[0]?.time?.data === 0 ? 0 : (storeInfo?.preparationTime?.[0]?.time?.data || 0)
      if (
        ddayjs()
          .subtract(3 + makeTime, 'minute')
          .format() >= cartMobx.info.startTime
      ) {
        showMsg(i18n.t('cart.timePickDsiabled'))
        timePickMobx.reset()
        return
      }
    }
    // 当前不可下单的状态
    if (!isCanOrder && !payMode) {
      if (!cartMobx.cartResult.totalCnt || !cartResult.isCanSave) {
        showMsg(i18n.t('cart.orderTipsProduct'))
        return
      } else if (!(((storeInfo.isMobileBookingOrder || timePickMobx.timePickList.length) && (cartMobx.info.startTime || (cartMobx.info.startTime === '' && storeInfo.inSale))) || storeInfo.inSale)) {
        showMsg(i18n.t('cart.orderTipsStore'))
        return
      }
      showMsg(i18n.t('cart.orderTips'))
      return
    }
    if (restaurantConfig.codeType === 'brand') {
      let _times = []
      const _asapTime = timePickMobx.asapTime.time ? `${ddayjs(timePickMobx.asapTime.time).format('YYYY-MM-DD')} ${timePickMobx.asapTime.timeStr}` : ''
      const _getTimeText = (startTime: string) => {
        const index = Number(ddayjs(startTime).format('YYYYMMDD')) - Number(ddayjs().format('YYYYMMDD'))
        const date = index >= 1 ? `${index === 1 ? i18n.t('checkout.tomorrow') : format.toDate(startTime)}` : ''
        return `${date} ${format.toTime(ddayjs(startTime).valueOf())}`
      }
      const _list = uniqBy(cloneDeep(cartMobx.viewCartItems).map(item => {
        const startTime = item.startTime || cartMobx.info.startTime || _asapTime
        return { startTime }
      }).filter(i => !!i.startTime), 'startTime')
      if (_list?.filter(i => i.startTime !== _asapTime)?.length || cartMobx.info.eatType === 'delivery') {
        _times = sortBy(_list, i => ddayjs(i.startTime).valueOf()).map(i => _getTimeText(i.startTime))
      }
      modalLayer(
        ConfirmModal,
        {
          className: `brand-orders-modal ${_times?.length ? '' : 'no-time-list'}`,
          confirmText: i18n.t('common.ok'),
          cancelText: i18n.t('common.cancel'),
          hasFooter: false,
          canClose: true,
          children: (
            eatType === 'delivery' ? (
              <div className='brand-order-detail'>
                <div className='title'>
                  <Icon name='delivery-title' />
                  {i18n.t('menu.delivery')}
                </div>
                <div className='address'>
                  <Icon name='location' />
                  {addressInfo?.address}
                </div>
                <div className='detail'>
                  {addressInfo?.realName} {addressInfo?.mobile}
                </div>
                {
                  _times?.length ? (
                    <div className='time-list'>
                      <div className='time-title'>
                        <Icon size={20} name='time2x' />
                        {i18n.t(`checkout.${cartMobx.info.eatType}${_times?.length > 1 ? 'OrderTimes' : 'OrderTime'}`)}
                      </div>
                      {_times?.map(item => <div key={item} className='time-item'>{item}</div>)}
                    </div>
                  ) : null
                }
                <div className='btn-box'>
                  <div className='btn-submit' data-cypid='bt-cart-delivery-footer-submit' onClick={() => handleDisableProductConfirm()}>{i18n.t('common.ok')}</div>
                </div>
              </div>
            ) : (
              <div className='brand-order-detail'>
                <div className='title'>
                  <Icon name='delivery-title' />
                  {i18n.t('menu.pickup')}
                </div>
                <div className='address'>
                  <Icon name='location' />
                  {storeInfo.storeName}
                </div>
                <div className='detail'>
                  {storeInfo.address}
                </div>
                <div className='store-tag'>
                  {
                    storeInfo.boughtCnt ? (
                      <span className='store-bought-cnt'><span className='txt'>{i18n.t('store.boughtStoreByStore', { num: storeInfo.boughtCnt })}</span></span>
                    ) : <></>
                  }
                  {
                    !!storeInfo.distanceWithUnit && (
                      <span className='store-distance'>
                        {i18n.t('menu.distance', { distance: storeInfo.distanceWithUnit })}
                      </span>
                    )
                  }
                </div>
                {
                  _times?.length ? (
                    <div className='time-list'>
                      <div className='time-title'>
                        <Icon size={20} name='time2x' />
                        {i18n.t(`checkout.${cartMobx.info.eatType}${_times?.length > 1 ? 'OrderTimes' : 'OrderTime'}`)}
                      </div>
                      {_times?.map(item => <div key={item} className='time-item'>{item}</div>)}
                    </div>
                  ) : null
                }
                <div className='btn-box'>
                  <div className='btn-submit' data-cypid='bt-cart-pickup-footer-submit' onClick={() => handleDisableProductConfirm()}>{i18n.t('common.ok')}</div>
                </div>
              </div>
            )
          ),
        },
        'confirmModal'
      ).then(() => {
        handleDisableProductConfirm()
      })
    } else {
      if (payMode) {
        handlePayAction()
      } else {
        handleDisableProductConfirm()
      }
    }
  }

  // 判断是否有售罄商品
  const handleDisableProductConfirm = () => {
    handlePayAction()
  }

  // 还有人未点单
  const showCheckLayer = (userList) => {
    modalLayer(ConfirmModal, {
      confirmText: i18n.t('menu.buyTogether.confirmBuy'),
      cancelText: i18n.t('menu.buyTogether.waitBuy'),
      className: 'bt-cart-order-modal',
      children: (
        <div className='bt-cart-modal-content'>
          <div className='title'>{i18n.t('menu.buyTogetherTip.tipPay1', { num: userList.length })}</div>
          <div className='user-wrap'>
            {
              userList.map(item => <Avatar key={item.personId} userKey={item.personId} />)
            }
          </div>
          <div className='desc'>{i18n.t('menu.buyTogetherTip.tipPay2')}</div>
        </div>
      )
    }, 'buyTogetherOrderConfirmModal').then((res: any) => {
      handleSaveOrder()
    }).catch(async (status: any) => {})
  }

  // 支付按钮逻辑
  const handlePayAction = () => {
    modalLayer.closeAll()
    // 若支付金额不为0，唤出收银台。否则直接支付
    if (payPlanMobx.totalAmount) {
      modalLayer(SettlementCard, null, 'settlementCardModal')
        .then(() => { })
        .catch(async () => {
          // if (payRechargeMobx.memberCardDiscountOnlyBalancePay) {

          // }
          await discountMobx.deleteOnlyBalancePay()
          await delayTime(500)
          await discountMobx.setOnlyBalancePay(true)
        })
    } else {
      payOrder({
        history,
        handlePayAction,
        handleSaveError: () => {
          modalLayer(ConfirmModal, {
            title: i18n.t('common.attention'),
            confirmText: i18n.t('cart.refreshMenu'),
            children: (<span>{i18n.t('cart.errorProduct')}</span>),
            className: 'cart-confirm-modal'
          }, 'confirmModal').then(() => {
            loadingLayer.show()
            restaurantCenter.initAll()
            setTimeout(() => loadingLayer.hide(), 2000)
          }).catch(() => {})
        }
      })
    }
  }

  const _payButtonRender = () => {
    return (
      <button
        className={`wide-btn${!isCanCheckout || !isCanDelivery || !isCanSingleSale ? ' disabled' : ''}`}
        onClick={() => {
          if (!isCanCheckout) {
            return
          }
          // 验证是否有人未点单
          let notSuccessUsers = []
          for (let key in multiPersonMobx.multiPersonMap) {
            let status = multiPersonMobx.multiPersonMap[key].status || TEnumUserStatus.init
            let notProd = !(cartMobx.viewUserCartItems[key]?.length > 0)
            if (status !== TEnumUserStatus.success && notProd) {
              notSuccessUsers.push(multiPersonMobx.multiPersonMap[key])
            }
          }
          // 未点餐的人数
          if (notSuccessUsers.length && !orderMobx.order?.ordersId) {
            showCheckLayer(notSuccessUsers)
            return
          }
          handleSaveOrder()
        }}
      >
        {
          isCanCheckout ? (
            isCanDelivery ? (
              isCanSingleSale ? (
                <>
                  {/* {i18n.t('newCart.settlement')} <big>{totalPrice}</big> */}
                  {i18n.t('pay.pay')} <big dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(payPlanMobx.totalAmount) }}></big>
                </>
              ) : (
                <>
                  {i18n.t('menu.canNotSingleSale')}
                </>
              )
            ) : (
              <>
                {
                  cartMobx.cartResult.itemActualPrice > 0 ? (
                    <>
                      <big dangerouslySetInnerHTML={{ __html: i18n.t('pay.diffDelivery', { price: format.toPriceLittleCurrency(deliveryMobx.leastFee - cartMobx.cartResult.itemActualPrice) }) }}></big>
                    </>
                  ) : (
                    <>
                      <big dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(deliveryMobx.leastFee) }}></big> {i18n.t('pay.leastDelivery')}
                    </>
                  )
                }
              </>
            )
          ) : (
            i18n.t('store.restingStore')
          )
        }
      </button>
    )
  }

  return (
    <IonFooter className='cart-footer'>
      <div className='cart-button-footer'>
        <button className='default-btn' data-cypid='bt-cart-footer-out' onClick={handleOutCart}>
          {i18n.t('common.back')}
        </button>
        {_payButtonRender()}
      </div>
    </IonFooter>
  )
}

export default observer(CartFooter)
